// export const BASE_URL = "https://iaxcloud.com/api/";
// export const BASE_URL = "http://localhost:8081/api/";
//export const BASE_URL = "http://192.168.1.192:8081/api/";
 export const BASE_URL = "https://profesoresback.iesalcantara.es/api/";

// export const SERVER_NAME = "https://iaxcloud.com/";
// export const SERVER_NAME = "http://localhost:8081/";
//export const SERVER_NAME = "http://192.168.1.192:8081/";
 export const SERVER_NAME = "https://profesoresback.iesalcantara.es/";

export const REV_PROXY_URL = "/acex/";
export const SECRET_KEY = '9He|2i?dx(>7uG|1:w+)uc527D2[r/';
export const KEY1 = "afsdjhjasd";
export const KEY2 = "sadiweuriou";